// CheckboxIconCheck.tsx
export const CheckboxIconCheck = () => (
  <svg
    className="icon-check"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33333 5L4.66667 8.33333L11.3333 1.66667"
      className="legion-checkbox_path"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

// CheckboxIconIndeterminate.tsx
export const CheckboxIconIndeterminate = () => (
  <svg
    className="icon-indeterminate"
    viewBox="0 0 12 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33333 1H10.6667"
      className="legion-checkbox_path"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
